import {
  API_STATUS,
  CLEAR_API_STATUS,
  GET_MAPPING_DATA,
  GET_VALI_DATA,
  IS_SIGNATURE_UPLOADED_STATUS,
  PDF_AND_PAGE_DETAILS,
  UPDATE_FILTER,
  VALIDATE_USER_STATUS,
} from "./types";
import { initialState } from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };

    case CLEAR_API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };

    case PDF_AND_PAGE_DETAILS: {
      return {
        ...state,
        pdfAndPageDetails: action.payload.data,
      };
    }

    case GET_MAPPING_DATA:
      return {
        ...state,
        coorData: action.payload,
      };

    case VALIDATE_USER_STATUS:
      return {
        ...state,
        validateUser: action.payload,
      };

    case IS_SIGNATURE_UPLOADED_STATUS:
      return {
        ...state,
        signUploaded: action.payload,
      };

    case UPDATE_FILTER:
      return {
        ...state,
        type: action.payload,
      };

    default: {
      return {
        ...state,
      };
    }
  }
};
export default reducer;
